import ClassicEditorBase  from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import CodePlugin from '@ckeditor/ckeditor5-basic-styles/src/code';
import CodeblockPlugin from '@ckeditor/ckeditor5-code-block/src/codeblock';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import BlockquotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import HtmlembedPlugin from '@ckeditor/ckeditor5-html-embed/src/htmlembed';
import ListuiPlugin from '@ckeditor/ckeditor5-list/src/list/listui';
import TodolistPlugin from '@ckeditor/ckeditor5-list/src/todolist';
import MediaembedPlugin from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import ImageinsertPlugin from '@ckeditor/ckeditor5-image/src/imageinsert';
import AutoimagetPlugin from '@ckeditor/ckeditor5-image/src/autoimage';
import ImageuploadPlugin from '@ckeditor/ckeditor5-image/src/imageupload';
import ImagetoolbarPlugin from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImagestylePlugin from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImagecaptionPlugin from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/image';
import Base64uploadadapterPlugin from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import IndentPlugin from '@ckeditor/ckeditor5-indent/src/indent';

export default class ClassicEditor extends ClassicEditorBase {}

ClassicEditor.builtinPlugins = [
    EssentialsPlugin,
    BoldPlugin,
    ItalicPlugin,
    LinkPlugin,
    ParagraphPlugin,
    UnderlinePlugin,
    HeadingPlugin,
    CodePlugin,
    BlockquotePlugin,
    CodeblockPlugin,
    HtmlembedPlugin,
    ListuiPlugin,
    TodolistPlugin,
    MediaembedPlugin,
    ImagePlugin,
    Base64uploadadapterPlugin,
    ImageuploadPlugin,
    ImageinsertPlugin,
    AutoimagetPlugin,
    ImagetoolbarPlugin,
    ImagestylePlugin,
    ImagecaptionPlugin,
    IndentPlugin                                                           // <--- ADDED
]

ClassicEditor.defaultConfig = {
    toolbar: [
        'heading',
        'bold',
        'italic',
        'underline',
        'code',
        'blockquote',
        'link',
        "|",
        'numberedList',
        'bulletedList',
        "|",
        'codeblock',
        'htmlembed',
        'todolist',
        'mediaembed',
        'imageupload',
        'imageinsert',
        'indent',
        'undo',
        'redo'
    ],
    heading: {
        options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
            {
                model: 'list_stype',
                view: {
                    name: 'p',
                    classes: 'list_stype'
                },
                title: 'list_stype',
                class: 'list_stype',

                // It needs to be converted before the standard 'heading2'.
                converterPriority: 'high'
            }
        ]
    },
    image: {
        toolbar: [
            "imageStyle:side", "|",
            "imageTextAlternative",
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:block',
            'imageStyle:side',
            'imageStyle:breakText', '|',
            'toggleImageCaption',
            'imageTextAlternative'
        ]
    },
    language: 'ru'
}